angular.module('impactx.smartform').config(['SmartFormTemplateCacheProvider', SmartFormConfig]);

function SmartFormConfig(SmartFormTemplateCacheProvider) {

    const USAGE_TYPES = {
        ALL: ["BASE", "RFQI", "RFQI_Q", "RFQI_I", "RFQI_DEF", "RFQI_Q_DEF", "RFQI_I_DEF", "APPROVER_MAIL", "SAP"],
        ALL_BUT_SAP: ["BASE", "RFQI", "RFQI_Q", "RFQI_I", "RFQI_DEF", "RFQI_Q_DEF", "RFQI_I_DEF", "APPROVER_MAIL"],
        SAP_ONLY: ["SAP"]
    };
    SmartFormTemplateCacheProvider.initialize(USAGE_TYPES);

    SmartFormTemplateCacheProvider.registerComponentTemplate('headline', {
        templateUrl: 'shared/smartform/templates/components/smart-form-headline.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-headline-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 1,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL,
        "@class": "SmartFormHeadline"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('divider', {
        templateUrl: 'shared/smartform/templates/components/smart-form-divider.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 1,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL,
        "@class": "SmartFormDivider"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('text', {
        value: 'Text',
        templateUrl: 'shared/smartform/templates/components/smart-form-text.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-text-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 1,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormText"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('textinput', {
        value: null,
        required: false,
        type: 'text',
        hint: null,
        templateUrl: 'shared/smartform/templates/components/smart-form-text-input.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-text-input-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormTextInput"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('numberinput', {
        value: null,
        required: false,
        onlyNatural: false,
        zeroAllowed: false,
        noDecimals: false,
        templateUrl: 'shared/smartform/templates/components/smart-form-number-input.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-number-input-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormNumberInput"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('rfcpositionfield', {
        value: null,
        templateUrl: 'shared/smartform/templates/components/smart-form-rfc-position-field.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-rfc-position-field-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.SAP_ONLY,
        "@class": "SmartFormRFCPositionField"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('rfctextfield', {
        value: null,
        templateUrl: 'shared/smartform/templates/components/smart-form-rfc-text-field.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-rfc-text-field-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.SAP_ONLY,
        "@class": "SmartFormRFCTextField"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('rfcnumberfield', {
        value: null,
        templateUrl: 'shared/smartform/templates/components/smart-form-rfc-number-field.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-rfc-number-field-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.SAP_ONLY,
        "@class": "SmartFormRFCNumberField"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('textarea', {
        value: null,
        required: false,
        templateUrl: 'shared/smartform/templates/components/smart-form-text-area.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-text-area-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 4,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormTextArea"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('checkbox', {
        value: false,
        required: false,
        templateUrl: 'shared/smartform/templates/components/smart-form-checkbox.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-checkbox-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 1,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormCheckbox"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('checkboxgroup', {
        options: [
            {label: 'Checkbox 1', value: false},
            {label: 'Checkbox 2', value: false},
            {label: 'Checkbox 3', value: false},
            {label: 'Checkbox 4', value: false},
        ],
        templateUrl: 'shared/smartform/templates/components/smart-form-checkbox-group.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-checkbox-group-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 4,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 4,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormCheckboxGroup"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('radiogroup', {
        value: 1,
        options: [
            {value: 1, label: 'Option 1'},
            {value: 2, label: 'Option 2'}
        ],
        templateUrl: 'shared/smartform/templates/components/smart-form-radio-group.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-radio-group-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 4,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 4,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormRadioGroup"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('select', {
        value: 0,
        required: false,
        removeEmptyOption: false,
        templateUrl: 'shared/smartform/templates/components/smart-form-select.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-select-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormSelect"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('date', {
        value: new Date(),
        templateUrl: 'shared/smartform/templates/components/smart-form-date-input.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-date-input-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormDateInput"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('time', {
        value: null,
        options: [ 1, 5, 10, 15, 60 ],
        templateUrl: 'shared/smartform/templates/components/smart-form-time-input.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-time-input-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormTimeInput"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('phonenumber', {
        value: {
            visible: true
        },
        required: false,
        templateUrl: 'shared/smartform/templates/components/smart-form-phone-number.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-phone-number-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 3,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormPhoneNumber"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('picture', {
        value: {},
        templateUrl: 'shared/smartform/templates/components/smart-form-picture.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-picture-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 5,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 1,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormPicture"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('upload', {
        value: {},
        templateUrl: 'shared/smartform/templates/components/smart-form-upload.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-upload-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 5,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 1,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormUpload"
    });

    SmartFormTemplateCacheProvider.registerComponentTemplate('slider', {
        value: 1,
        min: 0,
        max: 100,
        step: 1,
        templateUrl: 'shared/smartform/templates/components/smart-form-slider.tmpl.html',
        configurationPanelTemplateUrl: 'shared/smartform/templates/panels/smart-form-slider-configuration-panel.tmpl.html',
        layout: {
            sizeX: 1,
            sizeY: 1,
            row: 0,
            column: 0,
            minSizeX: 1,
            minSizeY: 2,
            maxSizeX: null,
            maxSizeY: null
        },
        allowedUsageTypes: USAGE_TYPES.ALL_BUT_SAP,
        "@class": "SmartFormSlider"
    });

    SmartFormTemplateCacheProvider.setDefaultSmartFormGridsterConfig({
        columns: 3, // the width of the grid, in columns
        pushing: true, // whether to push other items out of the way on move or resize
        floating: true, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
        swapping: false, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
        width: 'auto', // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
        colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
        rowHeight: '48', // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
        margins: [16, 16], // the pixel distance between each widget
        minColumns: 1, // the minimum columns the grid must have
        minRows: 1, // the minimum height of the grid, in rows
        maxRows: 100, // the maximum height of the grid in rows
        minSizeX: 1, // minimum vertical size of an component
        minSizeY: 1, // minimum horizontal size of an component
        defaultSizeX: 1, // the default width of a gridster item, if not specified
        defaultSizeY: 1, // the default height of a gridster item, if not specified
        mobileBreakPoint: 600, // if the screen is not wider that this, remove the grid layout and stack the items
        mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
        resizable: {
            handles: ['se'],
            enabled: true
        },
        draggable: {
            enabled: true, // whether dragging items is supported
        }
    });
}
